


<template>
  <div>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="首次课数量" name="first">
            <firstComponents v-if="activeName === 'first'" ref="firstChart" :translate="translate"></firstComponents>
        </el-tab-pane>
        <el-tab-pane label="首次课成功率" name="second">
            <secondComponents v-if="activeName === 'second'"  ref="secondChart" :translate="translate"></secondComponents>
        </el-tab-pane>
    </el-tabs> -->




    <el-tabs v-model="activeNames" @tab-click="handleClicks" type="border-card">

        <el-tab-pane label="整体" name="整体" v-if="getSubjectPermissions === 'S'">
            <el-tabs v-model="activeName" @tab-click="handleClick" >
                <el-tab-pane label="首次课数量" name="first">
                    <firstComponents v-if="activeName === 'first'"  type="首次课图表"  ref="firstChart" :translate="translate"></firstComponents>
                </el-tab-pane>
                <el-tab-pane label="首次课成功率" name="second">
                    <secondComponents v-if="activeName === 'second'"   type="首次课图表"  ref="secondChart" :translate="translate"></secondComponents>
                </el-tab-pane>
            </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="老师" name="老师" v-if="getSubjectPermissions === 'S'">
            <el-tabs v-model="TeacheractiveName" @tab-click="handleClickTeachera" >
              <el-tab-pane label="首次课数量" name="first">
                  <FistClassTableTeacherStart v-if="TeacheractiveName === 'first'"  type="首次课图表"  ref="FistClassTableTeacherStart" ></FistClassTableTeacherStart>
              </el-tab-pane>
              <el-tab-pane label="首次课成功率" name="second">
                  <FistClassTableTeacherEnd v-if="TeacheractiveName === 'second'"   type="首次课图表"  ref="FistClassTableTeacherEnd" ></FistClassTableTeacherEnd>
              </el-tab-pane>
            </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="学生" name="学生" v-if="getSubjectPermissions === 'S'">
           <el-tabs v-model="StudentactiveName" @tab-click="handleClickStudent" >
              <el-tab-pane label="首次课数量" name="first">
                  <FistClassTableStudentStart v-if="StudentactiveName === 'first'"  type="首次课图表"  ref="FistClassTableStudentStart" ></FistClassTableStudentStart>
              </el-tab-pane>
              <el-tab-pane label="首次课成功率" name="second">
                  <FistClassTableStudentEnd v-if="StudentactiveName === 'second'"   type="首次课图表"  ref="FistClassTableStudentEnd" ></FistClassTableStudentEnd>
              </el-tab-pane>
           </el-tabs>
        </el-tab-pane>


        <el-tab-pane label="学科组" name="学科组" v-if="getSubjectPermissions === 'Y' || getSubjectPermissions === 'S'">
           <el-tabs v-model="StudentactiveNames" @tab-click="handleClickStudents" >
              <el-tab-pane label="首次课数量" name="first">
                  <FistClassTableStudentStartcopycopycopycopycopy v-if="StudentactiveNames === 'first'" toAdd="学科组" type="首次课图表"  ref="FistClassTableStudentStart" ></FistClassTableStudentStartcopycopycopycopycopy>
              </el-tab-pane>
              <el-tab-pane label="首次课成功率" name="second">
                  <FistClassTableStudentEndcopy v-if="StudentactiveNames === 'second'"  toAdd="学科组" type="首次课图表"  ref="FistClassTableStudentEnd" ></FistClassTableStudentEndcopy>
              </el-tab-pane>
           </el-tabs>
        </el-tab-pane>

    </el-tabs>





  </div>
</template>



<script>

import firstComponents from './first.vue';
import secondComponents from './second.vue';

import FistClassTableTeacherStart from './FistClassTable/FistClassTableTeacherStart.vue';
import FistClassTableTeacherEnd from './FistClassTable/FistClassTableTeacherEnd.vue';
import FistClassTableStudentStart from './FistClassTable/FistClassTableStudentStart.vue';
import FistClassTableStudentEnd from './FistClassTable/FistClassTableStudentEnd.vue';

import FistClassTableStudentEndcopy from './FistClassTable/FistClassTableTeacherEndcopy.vue';
import FistClassTableStudentStartcopycopycopycopycopy from './FistClassTable/FistClassTableTeacherStartcopy.vue';


export default {
  name: 'FirstClassEchart',
  components: {
    firstComponents,
    secondComponents,
    FistClassTableStudentStartcopycopycopycopycopy,
    FistClassTableTeacherStart,
    FistClassTableTeacherEnd,
    FistClassTableStudentStart,
    FistClassTableStudentEnd,
    FistClassTableStudentEndcopy,
  },
  data() {
    return {
        activeName: 'first',
        activeNames: '整体',
        translate: null,


        TeacheractiveName : 'first', // 老师的activeName
        StudentactiveName : 'first', // 老师的activeName


        StudentactiveNames : 'first', // 学科组的activeName

        getSubjectPermissions: '',

    }
  },

  computed: {
   
  },

  mounted() {
     let getSubjectPermissions = sessionStorage.getItem('getSubjectPermissions')
    this.getSubjectPermissions = getSubjectPermissions

    if(this.getSubjectPermissions === 'Y'){
        this.activeName = '学科组'
        this.activeNames = '学科组'
     }

  },

  methods: {

    handleClicks(e){

    },


    handleClickTeachera(e){
      console.log(e, 'handleClickTeachera');


      this.activeName = 'first';
      this.StudentactiveName = 'first';
      
       
      if (e.name === 'second') {
          this.$nextTick(() => {
            this.$refs.FistClassTableTeacherEnd && this.$refs.FistClassTableTeacherEnd.handleGetDateList && this.$refs.FistClassTableTeacherEnd.handleGetDateList();
          });
      }

      
      
    },

    handleClickStudent(e){
        console.log(e, 'handleClickStudent');

        this.activeName = 'first';
        this.TeacheractiveName = 'first';
        // this.StudentactiveName = 'first';

        if (e.name === 'first') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentStart && this.$refs.FistClassTableStudentStart.handleGetDateList && this.$refs.FistClassTableStudentStart.handleGetDateList();
            });
        }

        if (e.name === 'second') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentEnd && this.$refs.FistClassTableStudentEnd.handleGetDateList && this.$refs.FistClassTableStudentEnd.handleGetDateList();
            });
        }

    },

    handleClickStudents(e){
        console.log(e, 'handleClickStudent');

        this.TeacheractiveNames = 'first';
        // this.StudentactiveName = 'first';

        if (e.name === 'first') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentStart && this.$refs.FistClassTableStudentStart.handleGetDateList && this.$refs.FistClassTableStudentStart.handleGetDateList();
            });
        }

        if (e.name === 'second') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentEnd && this.$refs.FistClassTableStudentEnd.handleGetDateList && this.$refs.FistClassTableStudentEnd.handleGetDateList();
            });
        }

    },

    handleClick(e){


        console.log(e, 'handleClick');


        this.activeName = e.name;
        this.translate = e;


        this.TeacheractiveName = 'first';
        this.StudentactiveName = 'first';

        if (e.name === 'first') {
            this.$nextTick(() => {
              this.$refs.firstChart && this.$refs.firstChart.initCharts && this.$refs.firstChart.initCharts();
            });
        }
        if (e.name === 'second') {
            this.$nextTick(() => {
              this.$refs.secondChart && this.$refs.secondChart.initCharts && this.$refs.secondChart.initCharts();
            });
        }
        
    },

  },


}


</script>




<style  scoped>


</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/FirstClassEchart.vue